import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import { useStatusReportContext } from '../../../../../statusReportContext'
import Comment from './Comment'
import CommentInput from './CommentInput'

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--dim-6)',
    flex: 1,
    height: '100%',
    overflow: 'hidden'
  },
  commentsList: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--dim-5)',
    overflow: 'auto'
  }
}))

function CommentList ({ comments = [], onAddComment, processing }) {
  const { report } = useStatusReportContext()
  const classes = useStyles()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const canAddComments = useMemo(() => {
    return report?.status === 'active'
  }, [report])

  const handleSubmit = async (text) => {
    if (!text.trim() || isSubmitting) return

    setIsSubmitting(true)
    try {
      await onAddComment(text)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.commentsList}>
        {comments?.sort((a, b) => {
          return new Date(a.createdDate) - new Date(b.createdDate)
        })?.map((comment) => (
          <Comment
            key={comment.commentId}
            comment={comment}
          />
        ))}
        {!comments?.length && (
          <p className='text-neutral-500 font-size-xs text-center font-light py-10'>
            No comments yet.
          </p>
        )}
      </div>
      {canAddComments && (
        <CommentInput
          onSubmit={handleSubmit}
          disabled={isSubmitting}
          processing={processing}
        />
      )}
    </div>
  )
}

CommentList.propTypes = {
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      commentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      text: PropTypes.string,
      createdDate: PropTypes.string,
      userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      userName: PropTypes.string,
      userAvatar: PropTypes.string,
      avatarType: PropTypes.oneOf(['media', 'override', 'resource', 'public'])
    })
  ),
  onAddComment: PropTypes.func,
  processing: PropTypes.bool
}

export default CommentList
